import { sendRequestResetPasswordAction } from 'redux/actions/authActions';
import { generateSimpleRequestReducer } from 'redux/utils/requestWithoutData';

export default generateSimpleRequestReducer(sendRequestResetPasswordAction);
